function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.1875 23.1875C8.1875 23.5332 8.4668 23.8125 8.8125 23.8125H23.1875C23.5332 23.8125 23.8125 23.5332 23.8125 23.1875V14.9844H8.1875V23.1875ZM23.1875 9.59375H19.9062V8.34375C19.9062 8.25781 19.8359 8.1875 19.75 8.1875H18.6562C18.5703 8.1875 18.5 8.25781 18.5 8.34375V9.59375H13.5V8.34375C13.5 8.25781 13.4297 8.1875 13.3438 8.1875H12.25C12.1641 8.1875 12.0938 8.25781 12.0938 8.34375V9.59375H8.8125C8.4668 9.59375 8.1875 9.87305 8.1875 10.2188V13.6562H23.8125V10.2188C23.8125 9.87305 23.5332 9.59375 23.1875 9.59375Z",
  fill: "#15A9E1"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 30.5,
  height: 30.5,
  rx: 15.25,
  stroke: "#15A9E1",
  strokeWidth: 1.5
});

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.7f48ab90.svg";
export { ForwardRef as ReactComponent };